import { render, staticRenderFns } from "./Agency.vue?vue&type=template&id=560198c9&scoped=true"
import script from "./Agency.vue?vue&type=script&lang=js"
export * from "./Agency.vue?vue&type=script&lang=js"
import style0 from "./Agency.vue?vue&type=style&index=0&id=560198c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560198c9",
  null
  
)

export default component.exports